import { EmptyHMD, HMD as HMDType } from './HMD';
import { EmptyRAP, RAP as RAPType } from './RAP';
import { EmptyRCR, RCR as RCRType } from './RCR';

export class SummaryMetric {
  rcr: RCRType;
  rap: RAPType;
  hmd: HMDType;

  constructor({ RCR, RAP, HMD }: any) {
    this.rcr = RCR;
    this.rap = RAP;
    this.hmd = HMD;
  }
}

export const EmptySummaryMetric: SummaryMetric = {
  rcr: EmptyRCR,
  rap: EmptyRAP,
  hmd: EmptyHMD,
};
